"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackJsRedirection = exports.default = void 0;

require("proxy-polyfill/proxy.min.js");

var _constants = require("./constants");

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * In order to let user import and use window._epicTracking object that is loaded via tracking.js
 * A Proxy interceptor is used here to load wondow._epicTracking dynamically
 * It will try to find _epicTracking in window object whenever this module gets called.
 */
var handler = {
  get: function get(obj, prop) {
    if (typeof window === 'undefined') throw new Error('epic-tracking is meant to be running in browser environment only');

    if (!window._epicTracking || _typeof(!window._epicTracking) === 'object') {
      // Ad blocker prevents tracking.js from loading.
      console.error('Unable to find _epicTracking object in global, please make sure it is installed');

      if (['configure', 'trackEvent', 'registerHistoryEvent'].includes(prop)) {
        return function () {
          return false;
        };
      }

      return false;
    }

    return window._epicTracking[prop];
  }
};
var epicTracking = new Proxy({}, handler);
var _default = epicTracking;
/**
 * Append epicTid query parameter to the url for url based tracking (trackingv2)
 * Any redirection invoked by js using window.location is not dectable by tracking.js due to browser protection.
 * @param {*} url
 * @return {url} url
 */

exports.default = _default;

var trackJsRedirection = function trackJsRedirection(inputUrl) {
  var outputUrl = inputUrl;

  try {
    var _qs$parseUrl = _queryString.default.parseUrl(inputUrl),
        url = _qs$parseUrl.url,
        query = _qs$parseUrl.query;

    if (!query[_constants.EPIC_TRACKING_UUID_PARAM] && window[_constants.EPIC_TRACKING_UUID]) {
      query[_constants.EPIC_TRACKING_UUID_PARAM] = window[_constants.EPIC_TRACKING_UUID];
      outputUrl = "".concat(url, "?").concat(_queryString.default.stringify(query));
    } else {
      console.warn('unable to find trackingUUID from global state', window[_constants.EPIC_TRACKING_UUID], query[_constants.EPIC_TRACKING_UUID_PARAM]);
    }
  } catch (ex) {
    console.warn('Failed to track url due to:', ex);
  }

  return outputUrl;
};

exports.trackJsRedirection = trackJsRedirection;